import { contains } from '@df/util/fn/contains';
import { NICmsDataChange } from '@icms/core/data/change/icms-data-change.service';
import { NICmsContentComponent } from '../../interfaces/icms-content-component.interfaces';
import { ICmsProviderAbstract, ICmsProviderStorage } from './icms-provider-abstract';

export class ICmsProviderDefault<T, TStorage extends ICmsProviderStorage<T> = ICmsProviderStorage<T>> extends ICmsProviderAbstract<
    T,
    TStorage
> {
    protected onChange(event: NICmsDataChange.IChangeDataEvent, instance: NICmsContentComponent.IComponent): void {
        if (!instance.initiated) {
            return;
        }
        const componentData = this.getStorage(instance).componentData$.getValue();
        //
        if (this.contentMeta.test) {
            console.log({
                event,
                componentData,
                isPrevious:
                    event.changeType === NICmsDataChange.EChangeType.change &&
                    (event as NICmsDataChange.IEventChange).previousValue === componentData,
                contains: contains(
                    componentData,
                    event.changedObject,
                    typeof this.contentMeta.watchDepth === 'number' ? this.contentMeta.watchDepth : Infinity
                )
            });
        }
        // if data is what has been changed we need to replace data
        if (
            event.changeType === NICmsDataChange.EChangeType.change &&
            componentData &&
            (event as NICmsDataChange.IEventChange).previousValue === componentData
        ) {
            this.setContent((event as NICmsDataChange.IEventChange).value, instance);
            // no change detection here, parent component handles that
        }
        // if data contain object that we changed, we do need to refresh
        else if (
            contains(
                componentData,
                event.changedObject,
                typeof this.contentMeta.watchDepth === 'number' ? this.contentMeta.watchDepth : Infinity
            )
        ) {
            instance.detectChanges({ [this.propertyKey]: new NICmsContentComponent.Mutation(event) });
        }
    }

    protected ngChanges(instance: NICmsContentComponent.IComponent) {
        this.setContent(instance[this.propertyKey], instance);
    }

    protected setContent(data: T, instance: NICmsContentComponent.IComponent): void {
        const componentData$ = this.getStorage(instance).componentData$;
        if (componentData$.getValue() !== data) {
            componentData$.next(data);
        }
    }

    protected getContent(instance: NICmsContentComponent.IComponent): T | undefined {
        return this.getStorage(instance).componentData$.getValue();
    }

    protected override getMeta(): NICmsContentComponent.IMeta | undefined {
        return (this.target.constructor.prototype as NICmsContentComponent.ICmsComponentType<NICmsContentComponent.IComponent>)._iCmsMeta;
    }
}
